module.exports = __webpack_public_path__ + "static/media/document.bfa766df.svg";